module.exports = __webpack_public_path__ + "img/search-and-subscribe-consumer.b7a69284.png";